import Commands from './commands';

class SIsEmpty extends Commands {
    constructor(registry) {
        super("sIsEmpty", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const container = this.registry.get(key);
        if (!container) {
            throw "Set not defined";
        }
        return container.size === 0;
    }
}

export default SIsEmpty;
